import probarFormularioVideo from "../img/Probar formulario contacto.mp4"
import postulacionesVideo from "../img/Postulaciones.mp4"
import borradoresVideo from "../img/Borradores.mp4"
import editarVideo from "../img/EditarEnLínea.mp4"

const videoTutoriales = [
  {
    title: "Probar formulario web",
    description:
      'Desde cualquier vista Cohortes, puedes abrir el menú del cohorte (tres puntos a la derecha) y seleccionar "Probar Formulario". El formulario de prueba no crea un prospecto en Salesforce, por lo que no ensucia los datos. Salesforce enviará un email con el resultado al correo indicado en "Email de aviso"',
    video: probarFormularioVideo,
  },
  {
    title: "Ver postulaciones",
    description:
      "En el menú Postulaciones podrás listar las últimas postulaciones de tus programas, ver sus detalles y desde ahí abrir la postulación en el sistema Postula.",
    video: postulacionesVideo,
  },
  {
    title: "Ver borradores",
    description:
      "En el menú Borradores podrás listar los cohortes que aún no han sido publicados, ver en destacado qué atributos obligatorios le faltan y desde ahí ir a editar el cohorte en el sistema Postula.",
    video: borradoresVideo,
  },
  {
    title: "Editar en línea",
    description:
      "En cualquier vista Cohortes, se puede editar un atributo para el que tenga los permisos por su rol, además podrá seleccionar varios cohortes y modificar un atributo para todos los seleccionados.",
    video: editarVideo,
  },
]

export default videoTutoriales
